(() => {
const names=['Titelbild','Vorderansicht','Lederdetail','Innenraum','Beschläge','Träger','Maße','Tragefoto'];
function setup(){
 const root=document.querySelector('[data-rv-color-product]');
 if(!root||root.dataset.colorReady)return;
 root.dataset.colorReady='true';
 const config=document.getElementById('RVCapriColors');
 if(!config)return;
 const sets=JSON.parse(config.textContent);
 const galleries=[...root.querySelectorAll('rv-color-gallery')];
 function apply(index){
  const input=root.querySelector('form[action*="/cart/add"] input[name="id"]');
  const variantId=input?.value||new URL(location.href).searchParams.get('variant')||root.dataset.initialVariant;
  const set=sets[variantId]||sets[root.dataset.initialVariant];
  if(!set)return;
  document.querySelectorAll('[data-rv-variant-image]').forEach(img=>{
   const position=Number(img.dataset.rvVariantImage)-1;
   if(!set.images[position])return;
   img.removeAttribute('srcset');img.src=set.images[position];
   img.alt='Capri – '+names[position]+' – '+set.color;
  });
  document.querySelectorAll('[data-rv-variant-color]').forEach(el=>el.textContent=set.color);
  document.querySelectorAll('[data-rv-strap-description]').forEach(el=>el.textContent=set.strapDescription);
  for(const gallery of galleries){
   const selected=Number(gallery.dataset.selected||0);
   const hero=gallery.querySelector('[data-rv-gallery-main]');
   hero.src=set.images[selected];hero.alt='Capri – '+names[selected]+' – '+set.color;
   gallery.querySelectorAll('[data-rv-gallery-index]').forEach((button,i)=>{
    const img=button.querySelector('img');img.src=set.images[i];img.alt='';
    button.setAttribute('aria-label','Capri '+set.color+' – '+names[i]);
    button.setAttribute('aria-pressed',String(i===selected));
   });
  }
 }
 for(const gallery of galleries){
  gallery.addEventListener('click',event=>{
   const button=event.target.closest('[data-rv-gallery-index]');if(!button)return;
   gallery.dataset.selected=button.dataset.rvGalleryIndex;apply();
  });
 }
 root.addEventListener('change',()=>apply());
 window.addEventListener('popstate',()=>apply());
 apply();
}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',setup);else setup();
document.addEventListener('shopify:section:load',setup);
})();